var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 1.125H7.40833C8.62178 1.125 9.2285 1.125 9.69198 1.36115C10.0997 1.56888 10.4311 1.90034 10.6388 2.30802C10.875 2.7715 10.875 3.37822 10.875 4.59167V8.4375M2.85833 10.875H7.24583C7.85256 10.875 8.15592 10.875 8.38766 10.7569C8.5915 10.6531 8.75723 10.4873 8.86109 10.2835C8.97917 10.0518 8.97917 9.74839 8.97917 9.14167V4.75417C8.97917 4.14744 8.97917 3.84408 8.86109 3.61234C8.75723 3.4085 8.5915 3.24277 8.38766 3.13891C8.15592 3.02083 7.85256 3.02083 7.24583 3.02083H2.85833C2.25161 3.02083 1.94825 3.02083 1.71651 3.13891C1.51267 3.24277 1.34694 3.4085 1.24308 3.61234C1.125 3.84408 1.125 4.14744 1.125 4.75417V9.14167C1.125 9.74839 1.125 10.0518 1.24308 10.2835C1.34694 10.4873 1.51267 10.6531 1.71651 10.7569C1.94825 10.875 2.25161 10.875 2.85833 10.875Z",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy3);
export default __webpack_public_path__ + "static/media/copy3.19d7653b125386cb94d142450815b6df.svg";
export { ForwardRef as ReactComponent };